import { AllHashFunctions, AllSchemas } from '@efdigital/ll-addon-data';
import { authHandler } from '@efdigital/ll-admin-v2/data/handlers/auth-handler';
import { DebugHandler } from '@efdigital/ll-admin-v2/data/handlers/debug-handler';
import { ltiRegistrationHandler } from '@efdigital/ll-admin-v2/data/handlers/lti-registration-handler';
import { TypeNormalizerHandler } from '@efdigital/ll-admin-v2/data/handlers/type-normalizer-handler';
import { LtiSchemas } from '@efdigital/ll-admin-v2/data/schemas/lti';
import type { HashFn } from '@warp-drive/core/types/schema/concepts';
import type {
  ObjectSchema,
  ResourceSchema,
} from '@warp-drive/core/types/schema/fields';
import { JSONAPICache } from '@warp-drive/json-api';
import { useLegacyStore } from '@warp-drive/legacy';

const store = useLegacyStore({
  linksMode: false,
  legacyRequests: true,
  modelFragments: true,
  cache: JSONAPICache,
  schemas: [
    ...(AllSchemas as (ResourceSchema | ObjectSchema)[]),
    ...(Object.values(LtiSchemas) as ResourceSchema[]),
  ],
  handlers: [
    ltiRegistrationHandler,
    new TypeNormalizerHandler(),
    new DebugHandler(),
    authHandler,
  ],
  hashFns: [...(AllHashFunctions as HashFn[])],
});

export default store;
